import { render, staticRenderFns } from "./ReporteDespachoVertedero.vue?vue&type=template&id=2e72f0b2&scoped=true&"
import script from "./ReporteDespachoVertedero.vue?vue&type=script&lang=js&"
export * from "./ReporteDespachoVertedero.vue?vue&type=script&lang=js&"
import style0 from "./ReporteDespachoVertedero.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReporteDespachoVertedero.vue?vue&type=style&index=1&id=2e72f0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72f0b2",
  null
  
)

export default component.exports